<template>
	<div>
		<v-skeleton-loader v-if="profileSectionLoading" v-bind="attrs" type="card" />
		<div v-else-if="profileSection">
			<UserInfo :userInfo="profileSection.publicProfile" />
		</div>
	</div>
</template>
<script>
import UserInfo from '@/components/User/UserInfo.vue'
import { mapActions, mapGetters } from 'vuex'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'PublicProfileInfo',
	components: { UserInfo },
	mixins: [Dwh],
	data() {
		return {
			attrs: {
				elevation: 0,
			},
		}
	},
	methods: {
		...mapActions('app', ['setPageTitle']),
		...mapActions('auth', ['getProfileSection', 'clearProfileSection']),
		dwhViewPublicProfile() {
			this.sendTrigger({
				category: 'Profile',
				action: 'view_public_profile',
				module: 'My Account',
				title: this.currentUser.visible_username,
				id1: this.currentUser.user_id,
			})
		},
	},
	computed: {
		...mapGetters('auth', [
			'profileSection',
			'profileSectionLoading',
			'profileSectionError',
			'profile',
		]),
		currentUser() {
			return this.profile
		},
	},
	mounted() {
		this.dwhViewPublicProfile()
		this.setPageTitle('Public Profile')
	},
	created() {
		this.getProfileSection('publicProfile')
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearProfileSection()
	},
}
</script>

<style lang="scss"></style>
